import {Subject} from 'rxjs';
import type {RechargeGiftScene} from './recharge-gift.service';

export interface RechargeGiftModalRequest {
  scene: RechargeGiftScene;
  onIneligible?: () => void;
  onUnavailable?: () => void;
  onDismiss?: () => void;
}

export const rechargeGiftModalRequest = new Subject<RechargeGiftModalRequest>();
export const rechargeGiftRouteUnavailable = new Subject<void>();

/** 主动查询并展示充值礼包弹窗。 */
export const showRechargeGiftModal = (
  scene: RechargeGiftScene = 'RECHARGE_ENTRY',
  options: Omit<RechargeGiftModalRequest, 'scene'> = {},
) => {
  rechargeGiftModalRequest.next({scene, ...options});
};
